import { Observer } from 'mobx-react-lite';
import React from 'react';
import { useProps, useStore } from '../../utils/mobx.utils';
var CurrencyRenderer = function (props) {
    var p = useProps(props);
    var s = useStore(function () { return ({
        get formatter() {
            return new Intl.NumberFormat('en-IE', {
                style: 'currency',
                currency: 'EUR',
            });
        },
        get isValid() {
            return p.value !== undefined && p.value !== null && !isNaN(typeof p.value === 'string' ? parseFloat(p.value) : p.value);
        },
        get formattedValue() {
            var _a;
            return p.value && s.isValid ? s.formatter.format(+p.value) : ((_a = p.emptyValue) !== null && _a !== void 0 ? _a : '--');
        },
        get formattedValueWithEmptyDecimalsHidden() {
            return s.formattedValue.replace(/\.00$/, '');
        }
    }); });
    return React.createElement(Observer, { children: function () { return (React.createElement("span", { className: "CurrencyRenderer", "data-currency": "EUR" }, p.trimEmptyDecimals ? s.formattedValueWithEmptyDecimalsHidden : s.formattedValue)); } });
};
export default CurrencyRenderer;
